import { useEffect } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { useDispatch, useSelector } from 'react-redux';

import MoreActions from 'core/lab/MoreActions';
import ReloadButton from 'core/buttons/ReloadButton';
import ColumnVisibility from 'core/table/ColumnVisibility';
import SelectPartner from 'components/partners/SelectPartner';
import TableActionsContainer from 'core/table/TableActionsContainer';

import Auth from 'utils/Auth';
import Sheet from 'utils/Sheet';
import app from 'app/config/app';
import useQueryParams from 'hooks/useQueryParams';
import { getPartnerCountries } from 'app/features/partner-countries/partnerCountrySaga';
import { setParam, deleteFilterParams } from 'app/features/partner-countries/partnerCountrySlice';

export default function PartnerCountriesActions({ table }) {
  const dispatch = useDispatch();

  const partnerCountryState = useSelector((state) => state.partnerCountries.index);

  const [queryParams, updateQueryParams] = useQueryParams(app.ignoreFilterKeys);

  // let availableFilters = [
  //   {
  //     label: 'Name',
  //     value: 'name',
  //   },
  //   {
  //     label: 'ID Number',
  //     value: 'id_number',
  //   },
  //   {
  //     label: 'Mobile Number',
  //     value: 'mobile_number',
  //   },
  //   {
  //     label: 'Email',
  //     value: 'email',
  //   },
  //   {
  //     label: 'Date of Birth',
  //     value: 'date_of_birth',
  //   },
  // ];

  const { params: appliedFilters } = partnerCountryState;

  // const [search, setSearch] = useState(appliedFilters?.search ?? '');

  // const handleOnFilter = useCallback((data) => {
  //   dispatch(setParam({ ...data, page_number: 1 }));
  // }, []);

  // const handleOnSearch = useCallback((e) => {
  //   setSearch(e.target.value);
  //   debounce(() => {
  //     dispatch(setParam({ search: e.target.value, page_number: 1 }));
  //   }, 500);
  // }, []);

  // const handleOnClearSearch = useCallback(() => {
  //   setSearch('');
  //   dispatch(deleteFilterParams('search'));
  // }, []);

  // const handleOnReset = useCallback((e) => {
  //   dispatch(deleteFilterParams([...availableFilters.map((filter) => filter.value)]));
  // });

  useEffect(() => {
    updateQueryParams(appliedFilters);
    // setSearch(appliedFilters?.search ?? '');
  }, [JSON.stringify(appliedFilters)]);

  useEffect(() => {
    dispatch(setParam(queryParams));
  }, [JSON.stringify(queryParams)]);

  return (
    <TableActionsContainer>
      <Box>
        {/* <SearchBox
          onChange={handleOnSearch}
          onClickClearSearch={handleOnClearSearch}
          value={search || ''}
        /> */}
      </Box>
      <Box display="flex" gap={1}>
        {Auth.isSuperAdmin() && (
          <SelectPartner
            id="select-partner"
            onSelected={(value) => {
              dispatch(setParam({ partner_id: value }));
            }}
            sx={{ width: '300px' }}
          />
        )}

        {/* <FilterPopup
          appliedFilters={appliedFilters}
          availableFilters={availableFilters}
          onFilter={(data) => handleOnFilter(data)}
          onReset={handleOnReset}
        /> */}

        {table && <ColumnVisibility table={table} />}
        <ReloadButton
          onClick={() => {
            dispatch(
              getPartnerCountries({
                ...appliedFilters,
                page_number: 1,
                partnerId: partnerCountryState.partnerId,
              }),
            );
          }}
        />
        <MoreActions
          onExportToCsv={() => Sheet.exportReactTableSelectedRowsToCsv(table, 'webhook_headers_')}
          onExportToExcel={() => Sheet.exportReactTableSelectedRowsToExcel(table, 'webhook_headers_')}
        />
      </Box>
    </TableActionsContainer>
  );
}

PartnerCountriesActions.propTypes = {
  table: PropTypes.object,
};
